
import { SecurityGoogleScreenNavigationProps } from "./types"
import React from "react"
import SecurityGoogle from "./security-google-screen"
import { PageRoot } from "~screens/page-root"


// 谷歌验证码
const SecurityGoogleScreen: React.FC<SecurityGoogleScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <SecurityGoogle route={route}/>
    </PageRoot>
  )
}

export default SecurityGoogleScreen
